import React, { useEffect, useState,useMemo } from "react";
import "../CmSearchSuggestionQAPair/CmSearchSuggestionsQAPair.Styles.css";
import { Grid } from "@mui/material";
import moment from "moment";
import { convertEpochToTimestamp } from "../../utils";
import sharedFolderCMReducer from "../../Reducer/sharedFolderCMReducer";
import { useSelector } from "react-redux";
import VizParagraph from "../VizParagraph/VizParagraph";
import { Tooltip } from "@mui/material";
import { Tag, Card, Divider } from "antd";
import { useNavigate } from "react-router-dom";
import { Home_PAGE_URL } from "../../Router/routerUrl";




export default function SearchSuggestionsQAPairInfo(props) {
	const [tagsArray, setTagsArray] = useState([])
	const history = useNavigate();
	const searchSuggestionsReducer = useSelector((state) => state.searchSuggestionsCM);
	const momentit = (stime) => {
		if (Number(Date.now()) - Number(stime) < 259200000) {
			return moment(new Date(Number(stime))).fromNow();
		} else {
			return moment(convertEpochToTimestamp(stime)).format("ll");
		}
	};
	const [timestamp, setTimestamp] = useState(props?.postedDate);
	const timeAgo = useMemo(() => momentit(timestamp), [timestamp]);
	// console.log(props,'check props')
	const keyTagArray = searchSuggestionsReducer?.keyTags && Object.values(searchSuggestionsReducer.keyTags).flat();
	const askSourceRender = (source) => {
		if (source === 'csv') {
			return (<span style={{ marginBottom: "0px", marginLeft: "5px" }}>&nbsp;via&nbsp;<Tooltip title="User added QA via XLS Atomizer">
				<i className="fa fa-file-excel-o" style={{ color: "#875c99" }}>
				</i></Tooltip>
			</span>)
		}
		if (source === 'Mobile')
			return (
				<><span>&nbsp;via&nbsp;</span><Tooltip title="User searched via Mobile Application"><img src={require('../../Images/32x32.png')} style={{ width: "16px" }} /></Tooltip></>
			)
		if (source === 'expert-QA') {
			return (
				<span>&nbsp;via&nbsp;<Tooltip title="User added QA via Expert role"><i class="fa fa-user-plus" aria-hidden="true" style={{ color: "#fb7432" }}></i></Tooltip></span>
			)
		}
		if (source === 'slack') {
			return (
				<><span>&nbsp;via&nbsp;</span><Tooltip title="User searched via Slack Vizerto bot"><img src={require("../../Images/slack-channel.png")} style={{ width: "16px" }} /></Tooltip></>
			)
		}
		if (source === 'slack-channel') {
			return (
				<><span>&nbsp;via&nbsp;</span><Tooltip title="User asked a question on slack channel"><img src={require("../../Images/slack-channel.png")} style={{ width: "16px" }} /></Tooltip></>
			)
		}
		if (source === 'msteams') {
			return (
				<><span>&nbsp;via&nbsp;</span><Tooltip title="User asked a question via MS Teams"><img src={require("../../Images/msteams.ico")} style={{ width: "16px" }} /></Tooltip></>
			)
		}
		if (source === 'msteams-channel') {
			return (
				<><span>&nbsp;via&nbsp;</span><Tooltip title="User asked a question via MS Teams Channel"><img src={require("../../Images/msteams.ico")} style={{ width: "16px" }} /></Tooltip></>
			)
		}
		if (source === 'webex') {
			return (
				<><span>&nbsp;via&nbsp;</span><Tooltip title="User asked a question via Webex"><img src={require("../../Images/webex.jpg")} style={{ width: "16px" }} /></Tooltip></>
			)
		}
		if (source === 'webex-channel') {
			return (
				<><span>&nbsp;via&nbsp;</span><Tooltip title="User asked a question via Webex channel"><img src={require("../../Images/webex.jpg")} style={{ width: "16px" }} /></Tooltip></>
			)
		}
		if (source === 'email') {
			return (
				<><span>&nbsp;via&nbsp;<Tooltip title="User asked a question via Email"><i className="fa fa-envelope" aria-hidden="true" style={{ color: "#875c99" }}></i></Tooltip></span></>
			)
		}
		if (source === 'Multi-Question') {
			return (
				<>
					<Tooltip title={`User asked a question via ${source}`}>
						<span>&nbsp;via&nbsp;<img src={require('../../Images/multiq.png')} style={{ width: '20px', background: '#1f93d2' }} /></span>
					</Tooltip>
				</>
			)
		}
	}
	useEffect(() => {
		const interval = setInterval(() => {
      setTimestamp(new Date()); 
    }, 60000); 
	const handleRefresh = () => {
		history(`${Home_PAGE_URL}suggestions`);
	  };
  
	  // Add event listener for beforeunload
	//   window.addEventListener('beforeunload', handleRefresh);
 
		if (props.tags !== undefined && props.tags !== '') {
			const newTag = props.tags.split(',')
			setTagsArray(newTag)
		}
		return () => clearInterval(interval); // Cleanup interval on unmount
	}, [props.tags,history])
	// return (
	// 	<>
	// 		<Grid container xs={12}>
	// 			<Grid item xs={12}>
	// 				<div className="suggestionContainer" style={{padding:'12px'}}>
	// 					<div className="headingContainer">
	// 						<h3>{props.data}</h3>
	// 					</div>
	// 					<Divider sx={{
	// 						backgroundColor: '#3e454c',
	// 						paddingLeft: '5px',
	// 						paddingRight: '5px',
	// 						marginTop: '15px',
	// 						marginBottom: '15px'
	// 					}} />
	// 					<Grid container>
	// 						{/* <Grid item xs={12} lg={6} md={6}> */}
	// 						<Grid item xs={12} lg={1} md={1}>
	// 							<span className="tagLabel">
	// 								Tags:
	// 							</span>
	// 						</Grid>
	// 						{
	// 							props.tags !== '' &&
	// 							<>
	// 								<Grid item xs={12} lg={2} md={2}>
	// 									{tagsArray.length > 0 && tagsArray.map((obj) => {
	// 										return (
	// 											<span className="tagsInSearchSuggestions">
	// 												{obj}
	// 											</span>
	// 										)
	// 									})}
	// 								</Grid>
	// 							</>
	// 						}
	// 						{/* </Grid> */}
	// 					</Grid>
	// 					<Grid container>
	// 						<Grid item xs={12} lg={1} md={1}>
	// 							<span className="tagLabel">
	// 								<span>
	// 									Asked By:
	// 								</span>
	// 							</span>
	// 						</Grid>
	// 						<Grid item xs={12} lg={2} md={2}>
	// 							<span className="expertName">
	// 								{props.seekerName}
	// 							</span>
	// 							{/* <span className="employeeText">
	// 								{props.userType}
	// 							</span> */}
	// 							<Tag style={{backgroundColor:'#1f93d2',color:'#fff',fontSize:'11px',fontWeight:'bold'}}>
	// 								{props?.userType}
	// 							</Tag>
	// 						</Grid>
	// 					</Grid>
	// 					<Grid container>
	// 						<Grid item xs={12} lg={1} md={1}>
	// 							<span className="tagLabel">
	// 								Posted Date:
	// 							</span>
	// 						</Grid>
	// 						<Grid item xs={12} lg={2} md={2}>
	// 							<span className="postedTimeStampText">
	// 								{/* {momentit(props.postedDate)} */}
	// 								{moment(props.postedDate).format('ll hh:mm A')}
	// 							</span>
	// 						</Grid>
	// 					</Grid>
	// 					{searchSuggestionsReducer.askedSource !== '' && searchSuggestionsReducer.askedSource !== 'Vizerto'
	// 						&&
	// 						<Grid container>
	// 							<Grid item xs={12} lg={1} md={1}>
	// 								<span className="tagLabel">
	// 									Asked Via:
	// 								</span>
	// 							</Grid>
	// 							<Grid item xs={12} lg={2} md={2}>
	// 								<VizParagraph type={5} weight={1}>{askSourceRender(searchSuggestionsReducer.askedSource)}</VizParagraph>
	// 							</Grid>
	// 						</Grid>}
	// 				</div>
	// 			</Grid>
	// 		</Grid>
	// 	</>
	// )


	return (
		<div className="mt-3" style={{ width: '100%' }}>
			<Card style={{ fontFamily: 'inherit' }} styles={{ body: { padding: '13px' } }} >
				<div className="headingContainer">
					<h3>{props.data}</h3>
				</div>
				<Divider style={{ margin: '5px' }} />
				<div style={{ display: 'flex' }}>
					<div style={{ width: '50%', display: 'flex', fontSize: '14px', fontWeight: 300 }}>
						<div style={{ width: '20%' }}>
							<div style={{ padding: '4px' }}>Asked By&nbsp;</div>
							<div style={{ padding: '4px' }}>Tags&nbsp;</div>
						</div>
						<div>
							<div style={{ padding: '4px' }}>
								<span className="expertName">{props.seekerName}</span>
								<Tag color={"var(--light_color_shade)"} style={{ fontFamily: 'inherit', backgroundColor: 'var(--light_color_shade)', color: '#fff' }}>{props.userType}</Tag>
							</div>
							<div style={{ padding: '4px' }}>
								{
									props.tags !== '' &&
									<>
										{keyTagArray?.length > 0 && keyTagArray.map((obj) => {
											return (
												<Tag color={"#aeaeae"} style={{fontFamily:'inherit',backgroundColor:'#aeaeae',color:'#fff'}}>
													{obj}
												</Tag>
											)
										})}
									</>
								}
							</div>
						</div>
					</div>
					<div style={{ width: '50%', display: 'flex', fontSize: '14px', fontWeight: 300 }}>
						<div style={{ width: '20%' }}>
							<div style={{ padding: '4px' }}>Domain&nbsp;</div>
							<div style={{ padding: '4px' }}>Posted Date&nbsp;</div>
						</div>
						<div style={{ width: '80%' }}>
							<div style={{ padding: '4px' }}>
								<Tag color={"#878787"} style={{ fontFamily: 'inherit', backgroundColor: '#878787', color: '#fff' }}>{searchSuggestionsReducer.includeDomainName}</Tag>
							</div>
							{<div style={{ padding: '4px' }}>
								{(props.postedDate !== 0) ? momentit(props.postedDate): "-"}
								{searchSuggestionsReducer?.askedSource !== 'Vizerto' &&searchSuggestionsReducer?.askedSource !== 'External Search' && 
									<span style={{
										float: 'inline-end',
										display: 'flex',
										alignItems: 'center'
									}}>
										asked{askSourceRender(searchSuggestionsReducer.askedSource)}
									</span>}
							</div>}
						</div>
					</div>
				</div>
			</Card >
		</div >
	)
}

